if (!customElements.get('count-up')) {
  class countUp extends HTMLElement {

    constructor() {
      super();

      const countTo = parseInt( this.dataset.countTo, 10 );
      const countSpeed = parseInt( this.dataset.countSpeed, 10 );
      this.animateValue(this, 0, countTo, countSpeed);
    }

    animateValue(obj, start, end, duration) {
      let startTimestamp = null;
      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        obj.innerHTML = Intl.NumberFormat('en-DE').format(Math.floor(progress * (end - start) + start));
        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }

  window.countUp = countUp;
  customElements.define('count-up', countUp);
}
